import React, { createContext, useState } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(sessionStorage.getItem('langOpt') || 'Japanese');

    const toggleLanguage = () => {
        setLanguage((prevLanguage) => (prevLanguage === "Japanese" ? "English" : "Japanese"));
    };

    return (
        <LanguageContext.Provider value={{ language,setLanguage, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
